/**
 * Shared fallback views. The onboarding wizard and ingested-data views are now
 * delivered by `clarity-onboarding-ingestion` (task 5.3) — see `Onboarding.tsx`
 * and the standalone store pages (`features/store/*`), rendered through the scope
 * tree's `WorkspaceSurface` + the onboarding-lock guard (clarity-navigation-
 * scope) — so the former placeholders are gone. `NotAuthorized` remains as the
 * role-gate fallback.
 */

/** Shown when a client-role user reaches an admin-only route (Req 6.6). */
export function NotAuthorized() {
  return (
    <section>
      <h2>Not authorized</h2>
      <p className="muted">
        This area is restricted to admin users. Server-side isolation enforces access regardless of
        this view (Req 2.3).
      </p>
    </section>
  );
}
